import { useMemo } from "react";
import {
  selectHandRaisedPeers,
  selectPeers,
  useHMSStore,
} from "@100mslive/react-sdk";
import { PARTICIPANT_ROLES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { ProviderPeersList } from "../types";
import { convertHMSPeerToPeer } from "./helpers";

export const useHMSPeersList = (): ProviderPeersList => {
  const hmsPeers = useHMSStore(selectPeers);
  const peers = useMemo(() => hmsPeers.map(convertHMSPeerToPeer), [hmsPeers]);
  const hosts = useMemo(
    () => peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.HOST),
    [peers],
  );
  const hmsPeersWithHandRaised = useHMSStore(selectHandRaisedPeers);
  const peersWithHandRaised = useMemo(
    () => hmsPeersWithHandRaised.map(convertHMSPeerToPeer),
    [hmsPeersWithHandRaised],
  );
  const spectators = useMemo(
    () =>
      peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.HLS_SPECTATOR),
    [peers],
  );
  const moderators = useMemo(
    () => peers.filter(peer => peer.roleName === PARTICIPANT_ROLES.MODERATOR),
    [peers],
  );

  return {
    peers,
    peersWithHandRaised,
    hosts,
    spectators,
    moderators,
  };
};
